import Com from "components/styledComp/CommStyledComp";
import React from "react";
import { useSelector } from "react-redux";

const CompanyHistory = () => {
    const compHistList = useSelector(state=>{
        return state.CompHist.value;
    });

    return (
        <Com.DivDetailSection border="false">
        <Com.DivDetailHeading>
            <Com.StrongStrategyCenter>회사 연혁</Com.StrongStrategyCenter>
        </Com.DivDetailHeading>
        <div className="background-list">
            {compHistList.map((history) => (
            <div className="background" key={history.year}>
                <Com.SpanHistory>{history.year}</Com.SpanHistory>
                <div className="background-parabox">
                <ul>
                    {history.items.map((item) => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
                </div>
            </div>
            ))}
        </div>
        </Com.DivDetailSection>
    );
};

export default CompanyHistory;
